<template>
  <NumeraiModal ref="modal" title="Logs" :width="1100">
    <template v-slot:activator>
      <slot></slot>
    </template>
    <div class="logs_modal_container">
      <button class="numerai-button refresh-button" @click="fetchLogs()">
        Refresh
      </button>
      <div class="table-container">
        <code>{{ logs }}</code>
      </div>
    </div>
  </NumeraiModal>
</template>

<script>
import NumeraiModal from '@/components/shared/NumeraiModal'

export default {
  components: {
    NumeraiModal,
  },
  props: {
    modelId: {
      type: String,
      required: true,
      default: null,
    },
    logStreamName: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      logData: [],
    }
  },
  computed: {
    logs() {
      let res = ''
      this.logData.forEach(logObj => {
        if (!logObj.timestamp) {
          res += logObj.message
        } else {
          let datetime = new Date(logObj.timestamp).toISOString()
          res += datetime + ': ' + logObj.message
        }
      })
      return res
    },
  },
  async created() {
    await this.fetchLogs()
  },
  methods: {
    async fetchLogs() {
      let _details
      if (!this.modelId || !this.logStreamName) {
        this.logData = [{ timestamp: null, message: 'Unable to retrieve logs' }]
        return
      }

      try {
        _details = await this.$client.invocationLogs(
          this.modelId,
          this.logStreamName,
        )
      } catch (err) {
        console.error(err)
        return
      }

      this.logData = _details
    },
  },
}
</script>

<style scoped>
code {
  width: 100%;
  padding: 0;
  overflow-x: scroll;
  white-space: pre;
  color: var(--color-primary);
  background-color: var(--color-anti-secondary);
}

.logs_modal_container {
  height: 650px;
  max-height: 95vh;
}

.refresh-button {
  float: right;
}

code:before {
  content: '';
}
</style>
